import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";

export default function LabelsIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/labels").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  useSeo({ title: "Ingredienti prodotti | Guatemalan Spirit", path: "/ingredienti",
    description: "Etichette digitali dei cocktail in fusto e dei liquori Guatemalan Spirit: ingredienti, allergeni, gradazione, valori energetici e produttore BOTTY srl.", jsonLd: [] });
  return (
    <div className="paper-grain min-h-screen">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 py-14" data-testid="labels-index">
        <div className="eyebrow text-[#C2593F] mb-3 flex items-center gap-2"><Leaf className="w-4 h-4" />Trasparenza</div>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-[#0B2A45] mb-4">Ingredienti prodotti</h1>
        <p className="text-stone-600 max-w-2xl mb-10">Le etichette digitali dei nostri cocktail in fusto e liquori: ingredienti, allergeni, gradazione alcolica, valori energetici e informazioni del produttore. Inquadra il QR code sul fusto o sulla bottiglia per aprire la scheda.</p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((l) => (
            <li key={l.slug}>
              <Link to={`/ingredienti/${l.slug}`} className="block bg-white rounded-2xl border border-stone-200 p-6 hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow]" data-testid={`label-card-${l.slug}`}>
                <h2 className="font-serif text-xl font-semibold text-[#0B2A45]">{l.name}</h2>
                <p className="text-sm text-stone-500 mt-1">Alc. {l.alc} · {l.format}</p>
                {l.allergens && <p className="text-xs mt-3 text-[#9A3412] bg-[#FFF7ED] inline-block px-2 py-1 rounded-full">Allergeni: {l.allergens}</p>}
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#0F4C81]">Vedi scheda <ArrowRight className="w-4 h-4" /></span>
              </Link>
            </li>
          ))}
        </ul>
        {items.length === 0 && <p className="text-stone-400" data-testid="labels-empty">Nessuna scheda pubblicata.</p>}
      </main>
      <Footer />
    </div>
  );
}
